import { Dayjs } from 'dayjs';
import {
  IGroupSchedule,
  IMappedGroupSchedule,
  mappedGroupSchedule,
} from 'entities/types';
import {
  dicsiplTypeToPrettyFormat,
  getParity,
  getTagsFromDayDate,
  getWeekDaysBetweenDates,
  isDateInInterval,
  isNeedToShowByWeekParityAndDateTime,
  locationToPrettyFormat,
  makeHash,
  subgroupNumber,
} from 'shared/lib';

export const mapGroupSchedule = (
  startDate: Dayjs,
  endDate: Dayjs,
  data: IGroupSchedule[],
): mappedGroupSchedule => {
  const scheduleMatrix: mappedGroupSchedule = [];

  const scheduleWeekDays = getWeekDaysBetweenDates(startDate, endDate);

  scheduleWeekDays.forEach((day, index) => {
    if (!scheduleMatrix[index]) {
      scheduleMatrix[index] = [];
    }

    const parity = getParity(day.date.toDate());

    const schedule = data.filter(
      (schedule) => +schedule.daynum === day.dayOfWeek,
    );

    let mapped: IMappedGroupSchedule;

    if (schedule.length && isDateInInterval(day.date.toDate())) {
      schedule.forEach((item, i) => {
        if (
          isNeedToShowByWeekParityAndDateTime({
            weekParity: parity,
            dayDate: item.daydate,
            searchingDate: day.date.toDate(),
          })
        ) {
          mapped = {
            date: day.date,
            dayDate: item.daydate,
            disciplName: item.disciplname,
            disciplType: dicsiplTypeToPrettyFormat(item.discipltype),
            disciplTime: item.daytime,
            location: locationToPrettyFormat({
              buildNum: item.building,
              audNum: item.auditory,
            }),
            department: item.kafTitle,
            subgroupNum: subgroupNumber({
              weekParity: parity,
              dayDate: item.daydate,
              searchingDate: day.date.toDate(),
            }),
            dateDayTags: getTagsFromDayDate(item.daydate),
            teacher: item.prepodfio,
            key: makeHash(
              day.date.format('DD.MM.YYYY') +
                i.toString() +
                item.prepodID +
                item.disciplname +
                item.daytime +
                item.daydate +
                item.auditory,
            ),
          };
          scheduleMatrix[index].push(mapped);
        }
      });
    }
  });
  return scheduleMatrix;
};
